import { render, staticRenderFns } from "./SteamAvatar.vue?vue&type=template&id=32031336&scoped=true"
import script from "./SteamAvatar.vue?vue&type=script&lang=js"
export * from "./SteamAvatar.vue?vue&type=script&lang=js"
import style0 from "./SteamAvatar.vue?vue&type=style&index=0&id=32031336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32031336",
  null
  
)

export default component.exports